$(document).ready(function () {
  var STORAGE_KEY = "totalfootball-apk-link";
  var apkBtn = document.querySelector(
    ".item__apk[data-download1][data-download2][data-download3]",
  );

  if (apkBtn) {
    var savedLink = localStorage.getItem(STORAGE_KEY);
    if (!savedLink) {
      var link1 = apkBtn.getAttribute("data-download1");
      var link2 = apkBtn.getAttribute("data-download2");
      var link3 = apkBtn.getAttribute("data-download3");
      var random = Math.random();
      if (random < 0.33) {
        savedLink = link1;
      } else if (random < 0.66) {
        savedLink = link2;
      } else {
        savedLink = link3;
      }
      localStorage.setItem(STORAGE_KEY, savedLink);
    }

    apkBtn.setAttribute("href", savedLink);
  }
});
